import { render, staticRenderFns } from "./ProfessionalDetailsActivity.vue?vue&type=template&id=7b70a9fb&"
import script from "./ProfessionalDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./ProfessionalDetailsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports